/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import LineChart from '../../component/Inc/LineChart';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
//image
import defaultImg from 'contents/assets/img/default_img.png';
function SubjectList() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [modalUploadImg, setModalUploadImg] = useState(false);
  const [modalLimit, setModalLimit] = useState(false);
  const [modalSend, setModalSend] = useState(false);
  const tab = [
    {title: '전체', value: 0},
    {title: '국어', value: 1},
    {title: '영어', value: 2},
    {title: '수학', value: 3},
    {title: '과탐', value: 4},
    {title: '사탐', value: 5},
    {title: '수시', value: 6}
  ];

  const lineChartWidth = '100%';
  const lineChartHeight = '220px';
  //Linechartlabels
  const lineChartlabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  //line chart data
  const lineChartData = {
    lineChartlabels,
    datasets: [
      {
        label: '2021',
        data: [2, 2, 1, 8, 5, 2, 6, 6, 10, 2, 3, 5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '2022',
        data: [1, 5, 9, 8, 1, 4, 5, 6, 3, 3, 10, 4],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      },
      {
        label: '2023',
        data: [1, 4, 5, 2, 5, 9, 7, 6, 6, 1, 8, 5],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#6d747f'
      }
    ]
  };
  return (
    <main className="com_container p_subject_list">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_1 active">교사목록 과목별</h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s">배전 제한된 교사</button>
            <button className="com_btn orange s btn_plus">교사 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_calendar_wrap has_option">
              <div className="option">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>
              <div className="year ">
                <button className="btn btn_first"></button>
                <button className="btn btn_prev"></button>
                <button className="btn_txt">2023</button>
                <button className="btn btn_next"></button>
                <button className="btn btn_last"></button>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">
                  <div className="chart_item">
                    <span className="chart_name_label">2021</span>
                    <div className="chart_slider chart_blue"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2022</span>
                    <div className="chart_slider chart_orange"></div>
                  </div>
                  <div className="chart_item">
                    <span className="chart_name_label">2023</span>
                    <div className="chart_slider chart_gray"></div>
                  </div>
                </div>
                <div className="chart_content">
                  <LineChart data={lineChartData} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="11.5%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>지점 선택</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option>본사</option>
                      </select>
                      <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                      <label htmlFor="rdo01">전체</label>
                      <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                      <label htmlFor="rdo02">대면</label>
                      <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                      <label htmlFor="rdo03">화상</label>
                      <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                      <label htmlFor="rdo04">수시</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수업가능 요일 선택</th>
                  <td className="td_left">
                    <input type="checkbox" id="chk01" className="com_chk" />
                    <label htmlFor="chk01">전체</label>
                    <input type="checkbox" id="chk02" className="com_chk" />
                    <label htmlFor="chk02">월</label>
                    <input type="checkbox" id="chk03" className="com_chk" />
                    <label htmlFor="chk03">화</label>
                    <input type="checkbox" id="chk04" className="com_chk" />
                    <label htmlFor="chk04">수</label>
                    <input type="checkbox" id="chk05" className="com_chk" />
                    <label htmlFor="chk05">목</label>
                    <input type="checkbox" id="chk06" className="com_chk" />
                    <label htmlFor="chk06">금</label>
                    <input type="checkbox" id="chk07" className="com_chk" />
                    <label htmlFor="chk07">토</label>
                    <input type="checkbox" id="chk08" className="com_chk" />
                    <label htmlFor="chk08">일</label>
                  </td>
                </tr>
                <tr>
                  <th rowSpan={2}>수업가능 지역 선택</th>
                  <td className="td_left">
                    <input type="radio" name="rdo" id="rdo02_1" className="com_chk circle" />
                    <label htmlFor="rdo02_1">전체</label>
                    <input type="radio" name="rdo" id="rdo02_2" className="com_chk circle" />
                    <label htmlFor="rdo02_2">서울</label>
                    <input type="radio" name="rdo" id="rdo02_3" className="com_chk circle" />
                    <label htmlFor="rdo02_3">경기</label>
                    <input type="radio" name="rdo" id="rdo02_4" className="com_chk circle" />
                    <label htmlFor="rdo02_4">인천</label>
                    <input type="radio" name="rdo" id="rdo02_4" className="com_chk circle" />
                    <label htmlFor="rdo02_4">부산</label>
                    <input type="radio" name="rdo" id="rdo02_4" className="com_chk circle" />
                    <label htmlFor="rdo02_4">경상남도</label>
                  </td>
                </tr>
                <tr>
                  <td className="td_left border_left">
                    <input type="radio" name="rdo" id="rdo03_1" className="com_chk circle" />
                    <label htmlFor="rdo03_1">전체</label>
                    <input type="radio" name="rdo" id="rdo03_2" className="com_chk circle" />
                    <label htmlFor="rdo03_2">강남구</label>
                    <input type="radio" name="rdo" id="rdo03_3" className="com_chk circle" />
                    <label htmlFor="rdo03_3">강동구</label>
                    <input type="radio" name="rdo" id="rdo03_4" className="com_chk circle" />
                    <label htmlFor="rdo03_4">강북구</label>
                    <input type="radio" name="rdo" id="rdo03_5" className="com_chk circle" />
                    <label htmlFor="rdo03_5">강서구</label>
                    <input type="radio" name="rdo" id="rdo03_6" className="com_chk circle" />
                    <label htmlFor="rdo03_6">관악구</label>
                    <input type="radio" name="rdo" id="rdo03_7" className="com_chk circle" />
                    <label htmlFor="rdo03_7">광진구</label>
                    <input type="radio" name="rdo" id="rdo03_8" className="com_chk circle" />
                    <label htmlFor="rdo03_8">구로구</label>
                    <input type="radio" name="rdo" id="rdo03_9" className="com_chk circle" />
                    <label htmlFor="rdo03_9">금천구</label>
                    <input type="radio" name="rdo" id="rdo03_10" className="com_chk circle" />
                    <label htmlFor="rdo03_10">노원구</label>
                    <input type="radio" name="rdo" id="rdo03_11" className="com_chk circle" />
                    <label htmlFor="rdo03_11">도봉구</label>
                    <input type="radio" name="rdo" id="rdo03_12" className="com_chk circle" />
                    <label htmlFor="rdo03_12">동대문구</label>
                    <input type="radio" name="rdo" id="rdo03_13" className="com_chk circle" />
                    <label htmlFor="rdo03_13">동작구</label>
                  </td>
                </tr>
                <tr>
                  <th>속성 / 공채</th>
                  <td className="td_left">
                    <input type="radio" name="rdo" id="rdo04_1" className="com_chk circle" />
                    <label htmlFor="rdo04_1">전체</label>
                    <input type="radio" name="rdo" id="rdo04_2" className="com_chk circle" />
                    <label htmlFor="rdo04_2">속성</label>
                    <input type="radio" name="rdo" id="rdo04_3" className="com_chk circle" />
                    <label htmlFor="rdo04_3">공채</label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search">
                <article className="option">
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                    <label htmlFor="chk010">원거리 가능</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk011" className="com_chk" />
                    <label htmlFor="chk011">무배정</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk011" className="com_chk" />
                    <label htmlFor="chk011">신규강사</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk012" className="com_chk" />
                    <label htmlFor="chk012">사진 미등록</label>
                  </span>
                  <span className="com_check_box lightRed">
                    <input type="checkbox" name="chk" id="chk013" className="com_chk" />
                    <label htmlFor="chk013">배정대기</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk014" className="com_chk" />
                    <label htmlFor="chk014">퇴사자</label>
                  </span>
                </article>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="3%" />
                <col width="5.5%" />
                <col width="5.5%" />
                <col width="5.5%" />
                <col width="5.5%" />
                <col width="6%" />
                <col width="9%" />
                <col width="6%" />
                <col width="7%" />
                <col width="7.5%" />
                <col width="auto" />
                <col width="3%" />
                <col width="3%" />
                <col width="3%" />
                <col width="3%" />
                <col width="3%" />
                <col width="6%" />
                <col width="4%" />
                <col width="4%" />
                <col width="4%" />
                <col width="4%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>이미지</th>
                  <th>교사명</th>
                  <th>수업방법</th>
                  <th>과목</th>
                  <th>시수</th>
                  <th>휴대폰</th>
                  <th>1순위 지역</th>
                  <th>원거리 가능</th>
                  <th>수업가능 요일</th>
                  <th>
                    <div className="com_calendar_wrap">
                      <div className="year ">
                        <button className="btn btn_first"></button>
                        <button className="btn btn_prev"></button>
                        <button className="btn_txt">2023</button>
                        <button className="btn btn_next"></button>
                        <button className="btn btn_last"></button>
                      </div>
                    </div>
                    <span className="sub">유지 / 수업수 / 손실률</span>
                  </th>
                  <th>진행</th>
                  <th>보류</th>
                  <th>인계</th>
                  <th>중단</th>
                  <th>종료</th>
                  <th>타임 / 가능타임</th>
                  <th>무배정</th>
                  <th>배정대기</th>
                  <th>배정상태</th>
                  <th>배정제한</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>3</td>
                  <td>
                    <button onClick={() => setModalUploadImg(true)} className="btn_link">
                      미등록
                    </button>
                  </td>
                  <td>홍길동101</td>
                  <td>대면</td>
                  <td>국어</td>
                  <td>800,000</td>
                  <td>010-111-1111</td>
                  <td>영등포구</td>
                  <td>Y</td>
                  <td>월 화 목 일</td>
                  <td>80.5 / 78 / A2</td>
                  <td className="bg_col">2</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col td_point">3 / 5</td>
                  <td className="bg_col">
                    <button onClick={() => setModalSend(true)} className="btn_link red">
                      151
                      <br />
                      2023, 05, 12 <br /> 발송
                    </button>
                  </td>
                  <td className="bg_col">6:20</td>

                  <td>퇴사대상</td>
                  <td>
                    <button onClick={() => setModalLimit(true)} className="com_btn lightGray xs">
                      배정
                      <br />
                      제한
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>
                    <img src={defaultImg} alt="이미지" />
                  </td>
                  <td>홍길동101</td>
                  <td>대면</td>
                  <td>국어</td>
                  <td>800,000</td>
                  <td>010-111-1111</td>
                  <td>영등포구</td>
                  <td>Y</td>
                  <td>월 화 목 일</td>
                  <td>80.5 / 78 / A2</td>
                  <td className="bg_col">2</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col td_point">3 / 5</td>
                  <td className="td_point bg_col">
                    151
                    <button className="com_btn orange xs cursor_default">
                      배정요청서 <br />
                      발송
                    </button>
                  </td>
                  <td className="bg_col">6:20</td>
                  <td>
                    배정요청서
                    <br />
                    보냄
                  </td>
                  <td>
                    <button className="btn_link red cursor_default">
                      배정제한
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>
                    <img src={defaultImg} alt="이미지" />
                  </td>
                  <td>홍길동101</td>
                  <td>대면</td>
                  <td>국어</td>
                  <td>800,000</td>
                  <td>010-111-1111</td>
                  <td>영등포구</td>
                  <td>Y</td>
                  <td>월 화 목 일</td>
                  <td>80.5 / 78 / A2</td>
                  <td className="bg_col">2</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">0</td>
                  <td className="bg_col">6:20</td>
                  <td className="bg_col td_point">3 / 5</td>
                  <td className="bg_col">
                    151
                    <button className="com_btn orange xs cursor_default">
                      배정요청서 <br />
                      발송
                    </button>
                  </td>
                  <td className="bg_col">6:20</td>
                  <td>
                    배정요청서
                    <br />
                    보냄
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <Paging />
              <div className="com_btn_wrap ">
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal open={modalUploadImg} close={() => setModalUploadImg(false)} type="type_alert">
        <h2 className="pop_tit">교사 사진 등록</h2>
        <div className="content_container">
          <div className="com_input_wrap flex_row">
            <div className="com_input_upload">
              <p className="file">
                <input type="text" className="input" defaultValue={`사진.jpg`} />
                <button type="button" className="btn_close_x" onClick={() => {}}></button>
              </p>
              <Upload title="+ 파일찾기" className="com_btn gray xs" />
            </div>
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
      <Modal open={modalLimit} close={() => setModalLimit(false)} type="type_alert">
        <div className="content_container mb_no">
          <div className="txt">배정제한을 하시겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
      <Modal open={modalSend} close={() => setModalSend(false)} type="type_alert">
        <div className="content_container mb_no">
          <div className="txt">배정요청서를 발송하겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default SubjectList;
